const HEADER_H2 = 'H2';
/**
 * This function is used on the anchor pages.
 * It gets the headings from the page's paragraph content,
 * extracts the ID and title text to populate the anchor menu.
 */
export const initAnchorMenu = () => {
  // Get the anchor menu <ul>
  const anchorMenu = document.getElementById('anchor-menu-list');
  // Check that the menu element exists.
  if (!anchorMenu) return;
  // Get all the headings with this class. Found in the "Heading" paragraph template
  const elements = document.getElementsByClassName('anchor-heading');

  for (let i = 0; i < elements.length; i++) {
    // For each heading, get the id, and title text from its <h2> tag
    const item = elements[i];
    const title = item.getElementsByClassName('anchor-heading-title')[0];
    // Only add anchors for H2 headings
    if (title.tagName !== HEADER_H2) continue;
    // Create the <li> element with the id, title and class, and append to anchor menu.
    const li = document.createElement('li');
    li.className = 'anchor-menu__link';
    li.innerHTML = `<a href="#${item.id}">${title.innerHTML}</a>`;
    anchorMenu.appendChild(li);
  }
};

export default 'initAnchorMenu';
